import { useEffect, useRef } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useCartTransfer } from '@/hooks/useCartTransfer';

/**
 * This component handles transferring guest cart items to authenticated cart when user logs in
 */
const CartTransferHandler = () => {
  const { user } = useAuth();
  const { transferGuestCartToAuthenticatedUser } = useCartTransfer();
  const previousUserRef = useRef<string | null>(null);

  useEffect(() => {
    // Check if user just logged in (user exists now but didn't before)
    const userJustLoggedIn = user?.id && !previousUserRef.current;
    
    if (userJustLoggedIn) {
      // Small delay to ensure cart hooks are initialized
      setTimeout(() => {
        transferGuestCartToAuthenticatedUser(user.id);
      }, 500);
    }

    // Update the previous user reference
    previousUserRef.current = user?.id || null;
  }, [user?.id, transferGuestCartToAuthenticatedUser]);

  // This component doesn't render anything
  return null;
};

export default CartTransferHandler;